import DicomUpload from './DicomUpload';

Object.assign(DicomUpload, { containerClassName: 'max-w-3xl' });

export default DicomUpload;
